export default __webpack_public_path__ + "static/media/discover.74778e52.svg";